import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'

// eslint-disable-next-line no-unused-vars
import { environment, app as firebaseApp, db } from '@/firebase/init'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import { profileStore } from '@/store/profile'
import { creatorService } from '@/services/creatorService'
import { snackbarService } from '@/services/snackbarService'

// ——— p5 setup ———
import p5 from 'p5' 
window.p5 = p5      // expose p5 before pulling in the sound library
import 'p5.sound'   // now the addon will augment window.p5

Vue.config.productionTip = false

Vue.use(vuetify, {
  iconfont: 'mdi' || 'fa'
})

// Make profileStore available in all components via this.$profileStore
Vue.prototype.$profileStore = profileStore
Vue.prototype.$creator = creatorService
Vue.prototype.$snackbar = snackbarService

Vue.prototype.$environment = environment
Vue.prototype.$isProduction = environment === 'production'
Vue.prototype.$isDevelopment = environment === 'development'
{
  const region = 'us-central1'
  const projectId = firebaseApp.options.projectId
  const base = `https://${region}-${projectId}.cloudfunctions.net`
  Vue.prototype.$endpoints = {
    generateImage: `${base}/generateImage`,
    // unified reasoning
    invokeLLM: `${base}/invokeLLM`,
    // unified Sparky chat (streams SSE)
    sparkyChat: `${base}/sparkyChat`,
    // deprecated streaming endpoints removed
    transcribeAudio: `${base}/transcribeAudio`,
    ideaverseInvoke: `${base}/ideaverseInvoke`,
  }
}

// Make common computed properties available globally
Vue.mixin({
  computed: {
    // Global access to current user profile (Firestore document)
    profile() {
      return this.$profileStore?.data || null
    },
    // Global access to Firebase auth user object
    authUser() {
      return this.$root?.user || null
    }
  },
  methods: {
    go: (route, params) => {
      console.log('go', route, params)
      let routeParams = {}
      // Handle params if provided
      if (params) {
        if (typeof params === 'string') {
          // If params is a string, assume it's an ID
          routeParams = { id: params }
        } else {
          // If params is an object, use it directly
          routeParams = params
        }
      }
      let link = router.resolve({ name: route, params: routeParams });
      if (link.resolved.matched.length > 0) {
        // Only navigate if we're not already on this route
        if (router.currentRoute.name !== route || JSON.stringify(router.currentRoute.params) !== JSON.stringify(routeParams)) {
          router.push({ name: route, params: routeParams }).catch(error => {
            // Only log non-navigation errors
            if (error.name !== "NavigationDuplicated") {
              console.log('ERROR', error);
            }
          });
        }
      } else {
        router.push({ name: 'Lost' });
      }
    },
  },
})

let app = null

// Initialize auth and create app
const auth = getAuth(firebaseApp)
onAuthStateChanged(auth, (user) => {
  if (!app) { // initialize app if not already created
    app = new Vue({
      router,
      vuetify,
      data: {
        user: user
      },
      render: h => h(App)
    }).$mount('#app')
  } else {
    app.user = user
  }
  
  // Sync profileStore with auth state
  if (user) {
    profileStore.fetchProfile()
  } else {
    profileStore.clearProfile()
  }
}, (error) => {
  console.error('Auth state change error:', error)
})